import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import TypedText from '../../components/TypedText';
import { renderProjectsByType } from '../../components/Project.js';
import CoreValues from '../../components/CoreValues/index.js';
import { coreValues } from '../../utils/constants.js';
import PortfolioPopover from './PortfolioPopover.jsx';

const Home = () => {
    return (
        <div className='home-page'>
            <header className='h-100 min-vh-100 d-flex align-items-center text-light'>
                <div className='container d-flex flex-column align-items-center'>
                    <h2>Welcome to</h2>
                    <div
                        className='text-center fw-semibold align-tems-center typed-container'>
                        <TypedText messages={['A To X Engineering Services S.A.R.L', 'From A to X, Engineering Excellence Defined.']} />
                    </div>
                    <div className='d-flex mt-4 flex-column flex-sm-row align-items-center'>
                        <Link to="/services">
                            <button type='button' className='btn bg-blue btn-outline-light btn-lg mx-0 mx-sm-2 my-2 my-sm-0'>Our Services</button>
                        </Link>
                       <PortfolioPopover />

                    </div>
                </div>
            </header>

            <div className="py-5">
                <CoreValues 
                    data={coreValues} 
                    title='CORE VALUES'
                    description='Our Guiding Principles for Exceptional Engineering Services'
                    />
            </div>

            <div className='main-projects-section text-light py-5'>
                <div className='container d-flex flex-column align-items-center'>
                    <h2 className='text-center text-capitalize mb-5'>Latest Projects in Architecture</h2>
                    <div className='row g-4'>
                        {renderProjectsByType('Architecture',null,3)}
                    </div>
                    <Link to="/projects?type=Architecture">
                        <button type='button' className='btn bg-blue btn-outline-light btn-lg mt-5'>More Projects</button>
                    </Link>
                </div>
                
            </div>
            <div className='main-projects-section text-light py-5'>
                <div className='container d-flex flex-column align-items-center'>
                    <h2 className='text-center text-capitalize mb-5'>Latest Projects in Engineering</h2>
                    <div className='row g-4'>
                        {renderProjectsByType('Engineering',null,3)}
                    </div>
                    <Link to="/projects?type=Engineering">
                        <button type='button' className='btn bg-blue btn-outline-light btn-lg mt-5'>More Projects</button>
                    </Link>
                </div>                
            </div>
            <div className='main-projects-section text-light py-5'>
                <div className='container d-flex flex-column align-items-center'>
                    <h2 className='text-center text-capitalize mb-5'>Latest Projects in Construction</h2>
                    <div className='row g-4'>
                        {renderProjectsByType('Construction',null,3)}
                    </div>
                    <Link to="/projects?type=Construction">
                        <button type='button' className='btn bg-blue btn-outline-light btn-lg mt-5'>More Projects</button>
                    </Link>
                </div>
                
            </div>
            
        </div>
    )
}

export default Home;